import $ from 'jquery';
$(".js-hamburger-icon").on("click", function () {
  $(this).toggleClass("is-active");
});
